import { onMounted, onUnmounted, ref } from '@vue/composition-api'

// by convention, composable function names start with "use"
export default function useWidth() {
  // state encapsulated and managed by the composable
  const windowWidth = ref(window.innerWidth)

  // a composable can update its managed state over time.
  function onResize() {
    windowWidth.value = window.innerWidth
  }

  // a composable can also hook into its owner component's
  // lifecycle to setup and teardown side effects.
  onMounted(() => window.addEventListener('resize', onResize))
  onUnmounted(() => window.removeEventListener('resize', onResize))

  // expose managed state as return value
  return { windowWidth }
}
